import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

// package.json
var name = "@vercel/analytics";
var version = "1.1.3"; // src/queue.ts

var initQueue = function initQueue() {
  if (window.va) return;

  window.va = function a() {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    (window.vaq = window.vaq || []).push(params);
  };
}; // src/utils.ts


function isBrowser() {
  return typeof window !== "undefined";
}

function detectEnvironment() {
  try {
    var env = process.env.NODE_ENV;

    if (env === "development" || env === "test") {
      return "development";
    }
  } catch (e) {}

  return "production";
}

function setMode() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "auto";

  if (mode === "auto") {
    window.vam = detectEnvironment();
    return;
  }

  window.vam = mode;
}

function getMode() {
  var mode = isBrowser() ? window.vam : detectEnvironment();
  return mode || "production";
}

function isProduction() {
  return getMode() === "production";
}

function isDevelopment() {
  return getMode() === "development";
}

function removeKey(key, _ref) {
  var _ = _ref[key],
      rest = _objectWithoutProperties(_ref, [key].map(_toPropertyKey));

  return rest;
}

function parseProperties(properties, options) {
  if (!properties) return void 0;
  var props = properties;
  var errorProperties = [];

  for (var _i = 0, _Object$entries = Object.entries(properties); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (typeof value === "object" && value !== null) {
      if (options.strip) {
        props = removeKey(key, props);
      } else {
        errorProperties.push(key);
      }
    }
  }

  if (errorProperties.length > 0 && !options.strip) {
    throw Error("The following properties are not valid: ".concat(errorProperties.join(", "), ". Only strings, numbers, booleans, and null are allowed."));
  }

  return props;
} // src/generic.ts


function inject() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    debug: true
  };

  var _a;

  if (!isBrowser()) return;
  setMode(props.mode);
  initQueue();

  if (props.beforeSend) {
    (_a = window.va) == null ? void 0 : _a.call(window, "beforeSend", props.beforeSend);
  }

  var src = isDevelopment() ? "https://va.vercel-scripts.com/v1/script.debug.js" : "/_vercel/insights/script.js";
  if (document.head.querySelector("script[src*=\"".concat(src, "\"]"))) return;
  var script = document.createElement("script");
  script.src = src;
  script.defer = true;
  script.setAttribute("data-sdkn", name);
  script.setAttribute("data-sdkv", version);

  script.onerror = function () {
    var errorMessage = isDevelopment() ? "Please check if any ad blockers are enabled and try again." : "Be sure to enable Web Analytics for your project and deploy again. See https://vercel.com/docs/analytics/quickstart for more information.";
    console.log("[Vercel Web Analytics] Failed to load script from ".concat(src, ". ").concat(errorMessage));
  };

  if (isDevelopment() && props.debug === false) {
    script.setAttribute("data-debug", "false");
  }

  document.head.appendChild(script);
}

function track(name2, properties) {
  var _a, _b;

  if (!isBrowser()) {
    var msg = "[Vercel Web Analytics] Please import `track` from `@vercel/analytics/server` when using this function in a server environment";

    if (isProduction()) {
      console.warn(msg);
    } else {
      throw new Error(msg);
    }

    return;
  }

  if (!properties) {
    (_a = window.va) == null ? void 0 : _a.call(window, "event", {
      name: name2
    });
    return;
  }

  try {
    var props = parseProperties(properties, {
      strip: isProduction()
    });
    (_b = window.va) == null ? void 0 : _b.call(window, "event", {
      name: name2,
      data: props
    });
  } catch (err) {
    if (err instanceof Error && isDevelopment()) {
      console.error(err);
    }
  }
}

var generic_default = {
  inject: inject,
  track: track
};
export { generic_default as default, inject, track };